import { render, staticRenderFns } from "./Table-Title-Row.vue?vue&type=template&id=47cb01e3&scoped=true"
import script from "./Table-Title-Row.vue?vue&type=script&lang=js"
export * from "./Table-Title-Row.vue?vue&type=script&lang=js"
import style0 from "./Table-Title-Row.vue?vue&type=style&index=0&id=47cb01e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb01e3",
  null
  
)

export default component.exports